import React from 'react';

import IntoLogo from '../IntoLogo/IntoLogo';
import SocialMediaIcons from '../SocialMediaIcons/SocialMediaIcons';

import styles from './Footer.module.scss';
import '../../styles/globals.scss';

export interface IFooter {
  chinaVersion: boolean;
  logoUrl: string;
  logoAriaLabel: string;
}

export default function Footer({ chinaVersion = false, logoUrl, logoAriaLabel }: IFooter) {
  const currentYear = new Date().getFullYear().toString();
  const tld = chinaVersion ? 'cn' : 'com';

  return (
    <footer className={styles.footer}>
      <div className={['into-container', styles.headerContainer].join(' ')}>
        <div className={styles.socialMediaContainer}>
          <SocialMediaIcons chinaVersion={chinaVersion} />
          <a href={logoUrl} aria-label={logoAriaLabel}>
            <IntoLogo className={styles.intoLogo} />
          </a>
        </div>
        <div className={styles.copyrightContainer}>
          <p data-testid="copyright">
            <span aria-hidden="true">&copy;</span> Copyright {currentYear} | INTO UNIVERSITY
            PARTNERSHIPS LTD AND IUP 2 LLP
          </p>
          <nav aria-label="footer">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              data-testid="icp-code"
              rel="noreferrer"
            >
              沪ICP备14028023号-15
            </a>
            <a href={`https://partnerportal2.intoglobal.${tld}/en/legal-and-privacy-policy`}>
              Legal & Privacy Policy
            </a>
            <a href={`https://partnerportal2.intoglobal.${tld}/en/cookies-policy`}>Cookie Policy</a>
            <a href={`https://partnerportal2.intoglobal.${tld}/en/accessibility-statement`}>Accessibility</a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
